import { Link } from "react-router-dom";

const footerLinks = {
  快速导航: [
    { label: "首页", to: "/" },
    { label: "使用指南", to: "/category/usage-guide" },
    { label: "常见问题", to: "/category/faq" },
    { label: "最新动态", to: "/category/latest-news" },
    { label: "安全指南", to: "/category/security-guide" },
  ],
  关于我们: [
    { label: "品牌介绍", to: "/about" },
    { label: "联系我们", to: "/about#contact" },
    { label: "信誉展示", to: "/about#reputation" },
  ],
  帮助中心: [
    { label: "登录教程", to: "/article/article-1" },
    { label: "登录失败排查", to: "/article/article-5" },
    { label: "找回密码", to: "/article/article-6" },
    { label: "账号安全", to: "/article/article-12" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-accent-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold" style={{ fontFamily: "var(--font-heading)" }}>
                <span className="text-accent-300">9170</span>
                <span className="text-background-50"> 官方指南</span>
              </span>
            </Link>
            <p className="text-accent-200/70 text-sm leading-relaxed">
              9170登录手机版入口官方指南，提供最新手机版登录地址、快速访问入口及常见问题解决方案。
            </p>
          </div>
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-background-50 font-semibold text-sm mb-4 whitespace-nowrap">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-accent-200/70 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-accent-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-accent-300/50 text-xs">
            &copy; 2026 9170官方指南. 保留所有权利。
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-accent-300/50 text-xs hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-accent-300/50 text-xs hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-accent-300/50 text-xs hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}